import React, { useEffect } from "react";
import heroImage from "./assets/vitrine/loom/header.jpg";
import lifecycleImage from "./assets/vitrine/loom/loom_section1.png";
import loomVideo from "./assets/vitrine/loom/weave.mp4";
import loom41 from "./assets/vitrine/loom/loom41.png";
import loom42 from "./assets/vitrine/loom/loom42.jpg";
import loom43 from "./assets/vitrine/loom/loom43.jpg";
import loom44 from "./assets/vitrine/loom/loom44.jpg";
import loom61 from "./assets/vitrine/loom/loom61.jpg";
import loom62 from "./assets/vitrine/loom/loom62.jpg";
import loom63 from "./assets/vitrine/loom/loom63.jpg";
import loom64 from "./assets/vitrine/loom/loom64.jpg";
import "./LoomPage.css";

const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.akremanaya.weavevomobile&hl=fr";


const LIFECYCLE = [
  {
    title: "1. Thread (Architecture)",
    text: "The creator structures the narrative blueprint, selects one of 6 foundational layouts (Storyboard, Gallery, Seed, Symphony, Relay, Versus), and provisions the escrow budget.",
  },
  {
    title: "2. In the Loom (Active Sourcing & Curation)",
    text: "Weavers reserve geolocated capture slots and submit media assets. The Loom tracks inputs and monitors incoming flows in real time.",
  },
  {
    title: "3. Woven (Perpetual Master)",
    text: "Media assets are unified, audio tracks balanced, and the living video is deployed. Individual scenes remain hot-swappable at any time without invalidating active links or printed QR codes.",
  },
];

const SLOT_CAPABILITIES = [
  {
    title: "Unit-level briefs",
    text: "Strict scene duration parameters (3 to 60 seconds, 5 to 8 seconds standard), perspective guides, and target compositions enforced via the AI Scene Wizard.",
  },
  {
    title: "Spatial anchoring",
    text: "Geolocated points of interest (POI) ensuring verified territorial authenticity.",
  },
  {
    title: "Preemption window",
    text: "Automated 120-minute reservation windows per slot to guarantee continuous contributor rotation.",
  },
  {
    title: "Perpetual hot-swap capability",
    text: "Individual scene updates can be executed in place without re-rendering or re-uploading the entire project.",
  },
  {
    title: "Multimodal Fit Scoring",
    text: "Powered by Gemini Multimodal, the engine compares submitted takes against the slot's visual and narrative brief to compute an alignment rating (Fit Score, e.g., Fit 67%), automatically tagging the best candidate with the AI selected badge.",
  },
  {
    title: "Real-Time Asynchronous Screening",
    text: "Creators can batch-analyze competing submissions across any slot on demand via Start AI screening, monitoring analysis progress in real time (e.g., 0/8, 2/8, 5/8) without interface reload.",
  },
  {
    title: "Contextual AI Insights",
    text: "An expandable inspection drawer displays qualitative AI reasoning, Weaver attribution",
  },
  {
    title: "AI Content Guard & Safety Checks",
    text: "Automated keyframe extraction via FFmpeg coupled with computer vision triages incoming video (Allow / Review / Block), enforcing an automated risk ceiling below 15% before assets reach the creator's queue.",
  },
  {
    title: "Trust Scoring & Authenticity Engine",
    text: "Perceptual hashing and EXIF metadata validation automatically flag stock video re-uploads, unauthorized duplicates, and geolocation discrepancies to ensure verified field authenticity.",
  },
  {
    title: "Creator-in-the-Loop Final Arbitrage",
    text: "Creators retain sovereign editorial authority—validating the winning clip with a single tap (1 approved), comparing concurrent takes, or directly filming missing scenes themselves via Contribute to this slot.",
  },
  {
    title: "Perpetual Hot-Swap Capability",
    text: "Individual scenes within a finalized, live video can be updated or swapped in place at any time without invalidating public URLs, engagement metrics, or printed QR codes.",
  },
];

const CREATOR_CONTROL = [
  {
    title: "Slot navigator",
    text: "Sequential pagination paired with an instant drop-down menu referencing all narrative stages across the project.",
  },
  {
    title: "Progress tracking",
    text: "Live status indicators displaying total submissions versus approved clips per slot.",
  },
  {
    title: "Hybrid fulfillment",
    text: "Creators can review community contributions or personally record missing slots using the direct Contribute to this slot trigger.",
  },
];

const AI_STACK = [
  {
    title: "AI Content Guard (Gemini Vision + FFmpeg)",
    text: "Automated keyframe extraction and safety policy evaluation (Allow / Review / Block) enforcing a strict risk ceiling under 15%.",
  },
  {
    title: "Studio AI Reviewer",
    text: "Contextual alignment assessment generating quantitative match ratings (Fit Score, e.g., Fit 67%) and automated selection tags (AI selected).",
  },
  {
    title: "Trust Scoring Engine",
    text: "Perceptual hash auditing, stock footage duplicate rejection, and EXIF consistency verification.",
  },
];

const STUDIO_CAPABILITIES = [
  {
    title: "Layout presets",
    text: "Dynamic visual layouts (Classic sequential, Grid 2x2, Parallax, Magazine...).",
  },
  {
    title: "Pacing & cadence",
    text: "Configurable automatic transitions (Cut, Fade, Slide, Zoom, Wipe).",
  },
  {
    title: "Semantic Cut-Point Detection (Gemini Multimodal)",
    text: "Algorithmic scanning analyzes incoming takes to detect peak visual moments and match kinetic transitions, ensuring actions flow uninterrupted from one contributor's scene to the next.",
  },
  {
    title: "Intelligent audio mastering",
    text: "Synchronized multilingual narration (Google Cloud TTS) and adaptive musical underscoring (MusicGen) with automated voice ducking.",
  },
  {
    title: "Multi-format delivery",
    text: "Native master output in .weave format, high-resolution 1080p/4K master exports, and vertical 9:16 aspect ratios.",
  },
  {
    title: "Cloud-Rendered Deliverables",
    text: "Automatically synthesizes distributed field inputs into unified master films, cross-platform campaign assets, and the proprietary, perpetually updatable .weave container.",
  },
];

const ESCROW_LOGIC = [
  {
    title: "Upfront escrow lock",
    text: "100% of the aggregate slot bounty budget is securely deposited into escrow prior to opening a project to contributions.",
  },
  {
    title: "Final-cut payout release",
    text: "Financial compensation is not disbursed upon simple upload or tentative approval; it is irreversibly transferred to the Weaver's In-App Wallet precisely when their contribution is selected and baked into the final published video (Woven state).",
  },
  {
    title: "Automated micro-splits",
    text: "Immediate distribution from the escrow pool to participating Weavers corresponding to their approved slots in the final master cut.",
  },
  {
    title: "Commercial rights clearance",
    text: "Inclusion in the finalized compilation completes the non-exclusive licensing transfer for the project while permanently maintaining full author attribution in the interactive player.",
  },
];

const CLOUD_BASELINE = [
  {
    title: "Elastic microservices pipeline",
    text: "Hosted on Google Cloud Platform to absorb high-concurrency upload surges and distributed media transcoding during live regional deployments.",
  },
  {
    title: "Performance metrics",
    text: "Sub-3.5 second AI inference latency per keyframe, with platform availability rated at 99.9%.",
  },
  {
    title: "Security & data sovereignty",
    text: "Comprehensive TLS 1.3 in transit, AES-256 at rest, strict GDPR alignment, and European cloud residency.",
  },
];

function CapabilityGrid({ items, compact = false }) {
  return (
    <div className={`loom-cardGrid ${compact ? "loom-cardGridCompact" : ""}`}>
      {items.map((item) => (
        <article className="loom-card" key={`${item.title}-${item.text}`}>
          <h3>{item.title}</h3>
          <p>{item.text}</p>
        </article>
      ))}
    </div>
  );
}

function PhoneGallery({ images }) {
  return (
    <div className="loom-phoneGallery">
      {images.map((src, index) => (
        <figure className="loom-phoneFrame" key={src}>
          <img src={src} alt="" loading="lazy" />
        </figure>
      ))}
    </div>
  );
}

export default function LoomPage() {
  useEffect(() => {
    document.title = "The Loom: Collaborative, Modular Video Assembly Engine";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="loom-page">
      <section className="loom-hero">
        <img className="loom-heroImage" src={heroImage} alt="" />
        <div className="loom-heroScrim" />
        <div className="loom-heroContent">
          <span className="loom-eyebrow">PROPRIETARY VIDEO ORCHESTRATION ENGINE</span>
          <h1>The Loom: Collaborative, Modular Video Assembly Engine</h1>
          <p>The proprietary infrastructure synchronizing distributed field captures, filtering footage via multimodal artificial intelligence, and compiling perpetual media assets inside the .weave container format.</p>
        </div>
      </section>

      <section className="loom-section loom-sectionLight">
        <div className="loom-heading">
          <h2>Narrative Lifecycle :Thread → In the Loom → Woven</h2>
          <p>A visual breakdown of a project's evolutionary states:</p>
        </div>
        <div className="loom-wideMedia loom-lifecycleMedia">
          <img src={lifecycleImage} alt="" loading="lazy" />
        </div>
        <CapabilityGrid items={LIFECYCLE} compact />
      </section>

      <section className="loom-section loom-sectionDark">
        <div className="loom-heading loom-headingOnDark">
          <h2>Slot-Based Modular Architecture &amp; Intelligent Curation</h2>
        </div>
        <div className="loom-videoShell">
          <video autoPlay muted loop playsInline controls preload="metadata">
            <source src={loomVideo} type="video/mp4" />
          </video>
        </div>
        <div className="loom-subheadingOnDark">Functional capabilities:</div>
        <CapabilityGrid items={SLOT_CAPABILITIES} />
      </section>

      <section className="loom-section loom-sectionLight">
        <div className="loom-heading">
          <h2>Operational Oversight and Media Arbitrage</h2>
          <p>The dedicated mobile management console designed to review and assign footage with single-tap precision.</p>
        </div>
        <PhoneGallery images={[loom41, loom42, loom43, loom44]} />
        <div className="loom-inlineLabel">Core interface elements:</div>
        <CapabilityGrid items={CREATOR_CONTROL} compact />
      </section>

      <section className="loom-section loom-sectionTint">
        <div className="loom-heading">
          <h2>Real-Time Content Screening &amp; Semantic Matching</h2>
          <p>Eliminating manual review bottlenecks through specialized cloud AI agents.</p>
        </div>
        <div className="loom-inlineLabel">Integrated AI stack:</div>
        <CapabilityGrid items={AI_STACK} compact />
      </section>

      <section className="loom-section loom-sectionLight">
        <div className="loom-heading">
          <h2>From Disparate Footage to Unified Master</h2>
          <p>Non-linear cloud editing without desktop post-production complexity.</p>
        </div>
        <PhoneGallery images={[loom61, loom62, loom63, loom64]} />
        <div className="loom-inlineLabel">Key capabilities:</div>
        <CapabilityGrid items={STUDIO_CAPABILITIES} />
      </section>

      <section className="loom-section loom-sectionDark loom-escrowSection">
        <div className="loom-heading loom-headingOnDark">
          <h2>Financial Attribution Executed Upon Final Inclusion</h2>
          <p>A transparent financial framework designed to safeguard project capital while rewarding verified impact.</p>
        </div>
        <div className="loom-subheadingOnDark">Attribution and escrow logic:</div>
        <CapabilityGrid items={ESCROW_LOGIC} />
        <a className="loom-textLink" href="/earning-model">explore Monetization</a>
      </section>

      <section className="loom-section loom-sectionLight">
        <div className="loom-heading">
          <h2>Enterprise-Grade Distributed Architecture</h2>
        </div>
        <div className="loom-inlineLabel">Technical baseline:</div>
        <CapabilityGrid items={CLOUD_BASELINE} compact />
      </section>
<section className="loom-mobileCta">
        <h2>Activate Your Organization Workspace on Mobile</h2>
        <p>Access your Living Weave campaigns within a sandboxed B2B workspace. Download the app to monitor ecosystem contributions and trigger The Loom's orchestration pipeline on iOS and Android.</p>
        <div className="loom-storeActions" aria-label="Download Weavevo">
          <a
            className="loom-storeButton loom-storeButtonPrimary"
            href={GOOGLE_PLAY_URL}
            target="_blank"
            rel="noreferrer"
            aria-label="Open Weavevo on the Play Store"
          >
            <i className="bi bi-google-play" aria-hidden="true" />
            <span>Play Store</span>
          </a>
          <button
            className="loom-storeButton loom-storeButtonSecondary"
            type="button"
            disabled
            aria-label="Weavevo App Store button"
            title="App Store"
          >
            <i className="bi bi-apple" aria-hidden="true" />
            <span>App Store</span>
          </button>
        </div>
      </section>
    </main>
  );
}
